import React, { Component } from 'react';

class SecuriForumForm extends Component {

	constructor(){
		super();
		this.state = {
			question3 : [],
			question4 : [],
			question5 : [],
		}
	}

	setForm = (event) => {
		this.props.setForm(event.target.name, event.target.value);
	};

	setFormCheckbox = (event) => {
		let checkboxes = this.state[event.target.name];
		if(event.target.checked){
			checkboxes.push(event.target.value);
		} else {
			checkboxes = checkboxes.filter(value => value !== event.target.value);
		}
		this.setState({
			[event.target.name] : checkboxes
		});
		this.props.setForm(event.target.name, checkboxes);
	};

	sendForm = (event) => {
		event.preventDefault();
		this.props.sendForm();
	};

	/**
	 *
	 * @returns {XML}
	 */
	render() {
		return (
			<form className="contact-form" method="POST" action="#">
				<div className="form-group">
					<label>Név</label>
					<input className="form-control" type="text" name="name"
					       placeholder="Név" tabIndex="1"
					       value={this.props.name} onChange={this.setForm}/>
				</div>
				<div className="form-group">
					<label>Telefonszám</label>
					<input className="form-control" type="tel" name="phone"
					       placeholder="Telefonszám" tabIndex="2"
					       value={this.props.phone} onChange={this.setForm}/>
				</div>
				<div className="form-group">
					<label>Email</label>
					<input className="form-control" type="email" name="email"
					       placeholder="Email" tabIndex="3"
					       value={this.props.email} onChange={this.setForm}/>
				</div>
				<div className="form-group">
					<label>Ön telepítő vagy értékesítő?</label>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question3" value="Telepítő" onChange={this.setFormCheckbox} />
								Telepítő
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question3" value="Értékesítő" onChange={this.setFormCheckbox} />
								Értékesítő
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question3" value="Add" onChange={this.setFormCheckbox}/>
							<input type="text" name="question3Add"
							       placeholder="Egyéb" onChange={this.setForm} />
						</label>
					</div>
				</div>
				<div className="form-group">
					<label>Jelenleg milyen rendszereket telepít?</label>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question4" value="CCTV" onChange={this.setFormCheckbox} />
							CCTV
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question4" value="AHD" onChange={this.setFormCheckbox} />
							AHD
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question4" value="IP" onChange={this.setFormCheckbox} />
							IP
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question4" value="Add" onChange={this.setFormCheckbox}/>
							<input type="text" name="question4Add"
							       placeholder="Egyéb" onChange={this.setForm} />
						</label>
					</div>
				</div>
				<div className="form-group">
					<label>Jelenleg milyen márkák termékeit telepíti, értékesíti?</label>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question5" value="Hikvision" onChange={this.setFormCheckbox} />
							Hikvision
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question5" value="Dahua" onChange={this.setFormCheckbox} />
							Dahua
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question5" value="Provision" onChange={this.setFormCheckbox} />
							Provision
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question5" value="Techson" onChange={this.setFormCheckbox} />
							Techson
						</label>
					</div>
					<div className="checkbox">
						<label>
							<input type="checkbox" name="question5" value="Add" onChange={this.setFormCheckbox}/>
							<input type="text" name="question5Add"
							       placeholder="Egyéb" onChange={this.setForm} />
						</label>
					</div>
				</div>
				<div className="form-group">
					<label>Ha IP kamerát vásárolhatna AHD áron akkor vásárolna?</label>
					<div className="radio">
						<label>
							<input type="radio" name="question6" value="Igen" onChange={this.setForm} />
							Igen
						</label>
					</div>
					<div className="radio">
						<label>
							<input type="radio" name="question6" value="Nem" onChange={this.setForm} />
							Nem
						</label>
					</div>
				</div>
				<div className="form-group">
					<label>Bármilyen szempontból jobbnak találja az IP kamerákat az AHD kamerákhoz képest?</label>
					<div className="radio">
						<label>
							<input type="radio" name="question7" value="Igen" onChange={this.setForm} />
							Igen
						</label>
					</div>
					<div className="radio">
						<label>
							<input type="radio" name="question7" value="Nem" onChange={this.setForm} />
							Nem
						</label>
					</div>
				</div>
				<button className="btn btn-amiko" type="submit" tabIndex="5"
				        onClick={this.sendForm}>Elküldöm</button>
			</form>
		);
	}
}

export default SecuriForumForm;


// WEBPACK FOOTER //
// ./src/components/form/SecuriForumForm.js